import moment from "moment"

export function DataFormatHelperTab(data: any) {
    return moment(data).format("DD/MM/YYYY HH:mm")
}

export function DataFormatHelperTabNoTime(data: any) {
    return moment(data).format("DD/MM/YYYY")
}